import { render, staticRenderFns } from "./RefTable.vue?vue&type=template&id=4a1e9490&"
import script from "./RefTable.vue?vue&type=script&lang=js&"
export * from "./RefTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports